import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { schedule } from "@ember/runloop";
import { modifier } from "ember-modifier";
import EmbedModeComposer from "discourse/components/embed-mode-composer";
import EmbedMode from "discourse/lib/embed-mode";
import ModMarketComposerCollapse from "../../components/mod-market-composer-collapse";
import { isModMarketDiscussionFrame } from "../../initializers/discourse-mod-market-embed-composer";

export default class ModMarketEmbedComposer extends Component {
  @tracked composerActionsHost;

  setupComposerActions = modifier(() => {
    if (!isModMarketDiscussionFrame({})) {
      return;
    }

    let destroyed = false;
    schedule("afterRender", () => {
      if (destroyed) {
        return;
      }

      const composerElement = document.querySelector(
        ".embed-mode-composer > .embed-mode-composer__composer"
      );
      if (!composerElement) {
        return;
      }

      // Core has no outlet between EmbedModeComposer and its DockedComposer.
      const host = document.createElement("div");
      host.classList.add("mod-market-composer-actions-host");
      composerElement.before(host);
      this.composerActionsHost = host;
    });

    return () => {
      destroyed = true;
      this.composerActionsHost?.remove();
      this.composerActionsHost = null;
    };
  });

  get shouldRenderNestedComposer() {
    return (
      EmbedMode.enabled &&
      isModMarketDiscussionFrame({}) &&
      this.args.outletArgs.model?.is_nested_view
    );
  }

  <template>
    <span hidden {{this.setupComposerActions}}></span>

    {{#if this.shouldRenderNestedComposer}}
      <EmbedModeComposer @topic={{@outletArgs.model}} />
    {{/if}}

    {{#if this.composerActionsHost}}
      {{#in-element this.composerActionsHost insertBefore=null}}
        <ModMarketComposerCollapse />
      {{/in-element}}
    {{/if}}
  </template>
}
